import { render, staticRenderFns } from "./Benchmarking.vue?vue&type=template&id=7483d108&scoped=true"
import script from "./Benchmarking.vue?vue&type=script&lang=js"
export * from "./Benchmarking.vue?vue&type=script&lang=js"
import style0 from "./Benchmarking.vue?vue&type=style&index=0&id=7483d108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7483d108",
  null
  
)

export default component.exports